import moment from 'moment';

export default time => {
  return time && moment(time).format('l LT');
};



// WEBPACK FOOTER //
// ./src/utils/formatTime.js